// ────────────────────────────────────────────────────────────────────────────
// HELPER: Extract dispatch information from order
// ────────────────────────────────────────────────────────────────────────────

export const getDispatchBadges = (order) => {
  const badgeMap = {};

  if (Array.isArray(order?.dispatchDetails)) {
    order.dispatchDetails.forEach((dispatch) => {
      if (!dispatch?.type || !dispatch?.status) return;

      const displayType =
        dispatch.type === "Sample" ? "Sample Delivery" : "Full Order Delivery";

      const key = `${displayType}-${dispatch.status}`;

      if (!badgeMap[key]) {
        badgeMap[key] = {
          type: dispatch.type,
          status: dispatch.status,
          displayType,
          color: getDispatchColor(dispatch.status),
          icon: getDispatchIcon(dispatch.status),
          label: dispatch.status.replace(/_/g, " "),
          count: 1,
        };
      } else {
        badgeMap[key].count++;
      }
    });
  }

  return Object.values(badgeMap);
};

// ────────────────────────────────────────────────────────────────────────────
// Helper: Get color based on dispatch status
// ────────────────────────────────────────────────────────────────────────────

const getDispatchColor = (status) => {
  switch (status) {
    case "Ready_To_Dispatch":
      return "amber"; // Yellow - ready but not yet dispatched
    case "Dispatched":
      return "blue"; // Blue - in transit
    case "Delivered":
      return "emerald"; // Green - delivered
    default:
      return "gray";
  }
};

// ────────────────────────────────────────────────────────────────────────────
// Helper: Get icon based on dispatch status
// ────────────────────────────────────────────────────────────────────────────

const getDispatchIcon = (status) => {
  switch (status) {
    case "Ready_To_Dispatch":
      return "📦"; // Package ready
    case "Dispatched":
      return "🚚"; // In transit
    case "Delivered":
      return "✅"; // Delivered
    default:
      return "📋";
  }
};

// ────────────────────────────────────────────────────────────────────────────
// Helper: Get color styles for badges
// ────────────────────────────────────────────────────────────────────────────

const getDispatchBadgeStyles = (color) => {
  const colorMap = {
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    blue: "bg-blue-50 text-blue-700 border-blue-200",
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    gray: "bg-gray-100 text-gray-500 border-gray-200",
  };
  return colorMap[color] || colorMap.gray;
};

export { getDispatchBadgeStyles };
